module.exports = __webpack_public_path__ + "static/media/icon-twitter.3db74330.svg";